import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5a11c2c5")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("rect", {
  x: "3",
  y: "11",
  width: "18",
  height: "11",
  rx: "2",
  ry: "2"
}, null, -1)
_popScopeId()

import { HtmlInputEvent } from '@/types';
import { ref, computed, watchEffect } from 'vue';
import useTokens from '@/composables/useTokens';
import TokenSelectInput from '@/components/inputs/TokenSelectInput/TokenSelectInput.vue';
import { TokenInfo } from '@/types/TokenList';

/**
 * TYPES
 */
type InputValue = string | number;

type Props = {
  address?: string;
  weight?: number;
  label?: string;
  fixedToken?: boolean;
  hint?: string;
  hintAmount?: string;
  excludedTokens?: string[];
};

/**
 * PROPS & EMITS
 */
import anime from 'animejs';

/**
 * COMPUTED
 */

export default _defineComponent({
  props: {
    address: { type: String, required: false, default: '' },
    weight: { type: Number, required: false, default: 0 },
    label: { type: String, required: false },
    fixedToken: { type: Boolean, required: false },
    hint: { type: String, required: false },
    hintAmount: { type: String, required: false, default: '' },
    excludedTokens: { type: Array, required: false }
  } as unknown as undefined,
  emits: ["blur", "input", "update:weight", "update:address", "update:isValid", "update:isLocked", "keydown", "delete"] as unknown as undefined,
  setup(__props: {
  address?: string;
  weight?: number;
  label?: string;
  fixedToken?: boolean;
  hint?: string;
  hintAmount?: string;
  excludedTokens?: string[];
}, { emit }: { emit: ({
  (e: 'blur', value: string): void;
  (e: 'input', value: string): void;
  (e: 'update:weight', value: string): void;
  (e: 'update:address', value: string): void;
  (e: 'update:isValid', value: boolean): void;
  (e: 'update:isLocked', value: boolean): void;
  (e: 'keydown', value: HtmlInputEvent);
  (e: 'delete'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




/**
 * STATE
 */
const _weight = ref<InputValue>('');
const _address = ref<string>('');
const lockPath = ref<HTMLElement>();
const lockIcon = ref<HTMLElement>();
const isLocked = ref(false);

/**
 * COMPOSABLEs
 */
const { getToken } = useTokens();
const hasToken = computed(() => !!_address.value);

const token = computed((): TokenInfo | undefined => {
  if (!hasToken.value) return undefined;
  return getToken(_address.value);
});

/**
 * METHODS
 */
function lockWeight(keepLocked?: boolean) {
  if (isLocked.value && !keepLocked) {
    anime({
      targets: lockPath.value,
      d: 'M7 11V7a5 4 0 0 1 10 -2v-1',
      easing: 'spring(0.2, 80, 10, 0)'
    });
    isLocked.value = false;
  } else {
    if (!isLocked.value) {
      anime({
        targets: lockPath.value,
        d: 'M7 11V7a5 5 0 0 1 10 0v4',
        easing: 'spring(0.2, 80, 10, 0)'
      });

      anime({
        delay: 125,
        targets: lockIcon.value,
        translateY: '1px',
        easing: 'linear',
        duration: 100,
        complete: () => {
          anime({
            targets: lockIcon.value,
            translateY: '0px',
            easing: 'linear',
            duration: 100
          });
        }
      });
    }
    isLocked.value = true;
  }
  emit('update:isLocked', isLocked.value);
}

function onInput(event) {
  emit('input', event);
  lockWeight(true);
}

/**
 * CALLBACKS
 */
watchEffect(() => {
  _weight.value = props.weight;
  _address.value = props.address;
});

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_BalTextInput = _resolveComponent("BalTextInput")!

  return (_openBlock(), _createBlock(_component_BalTextInput, _mergeProps({
    name: "weight",
    modelValue: _weight.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_weight.value = $event)),
    placeholder: __props.hintAmount || '0.0',
    type: "number",
    label: __props.label,
    decimalLimit: _unref(token)?.decimals || 18,
    validateOn: "input",
    autocomplete: "off",
    autocorrect: "off",
    noShadow: "",
    noBorder: "",
    noRadius: "",
    step: "any",
    spellcheck: "false"
  }, _ctx.$attrs, {
    inputAlignRight: "",
    onBlur: _cache[5] || (_cache[5] = ($event: any) => (emit('blur', $event))),
    onInput: onInput,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (emit('update:weight', $event))),
    "onUpdate:isValid": _cache[7] || (_cache[7] = ($event: any) => (emit('update:isValid', $event))),
    onKeydown: _cache[8] || (_cache[8] = ($event: any) => (emit('keydown', $event)))
  }), {
    prepend: _withCtx(() => [
      _createVNode(TokenSelectInput, {
        modelValue: _address.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_address.value = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (emit('update:address', $event)))
        ],
        fixed: __props.fixedToken,
        class: "mr-2",
        excludedTokens: __props.excludedTokens
      }, null, 8, ["modelValue", "fixed", "excludedTokens"])
    ]),
    append: _withCtx(() => [
      _createVNode(_component_BalStack, {
        align: "center",
        horizontal: "",
        spacing: "none"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "percent",
            size: "sm",
            class: "mt-2 text-gray-600"
          }),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (lockWeight(false))),
            class: _normalizeClass([
            'ml-2 ease-color mt-2 text-black hover:text-red-800 flex items-center shadow-sm border rounded-full p-1 justify-center',
            {
              'text-red-500 dark:text-red-500': isLocked.value,
              'border-transparent': !isLocked.value
            }
          ]),
            style: {"background":"#FEF7E5","border-color":"#D8CEB5"}
          }, [
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "feather feather-unlock",
              ref: lockIcon
            }, [
              _hoisted_1,
              _createElementVNode("path", {
                ref: lockPath,
                d: "M7 11V7a5 4 0 0 1 10 -2v-1"
              }, null, 512)
            ], 512))
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('delete'))),
            class: _normalizeClass([
            'ml-2 ease-color mt-2 text-black hover:text-red-500 flex items-center border rounded-full p-1 justify-center'
          ]),
            style: {"background":"#FEF7E5","border-color":"#D8CEB5"}
          }, [
            _createVNode(_component_BalIcon, {
              name: "trash-2",
              size: "sm"
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue", "placeholder", "label", "decimalLimit"]))
}
}

})